var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.625 4.91663L14.625 8.87496L0.375 8.87496L0.375 4.91663L14.625 4.91663ZM13.0417 6.23607L1.95833 6.23607L1.95833 7.55551L13.0417 7.55551L13.0417 6.23607Z",
    fill: "#1B407A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.625 9.66663L14.625 13.625L0.375 13.625L0.375 9.66663L14.625 9.66663ZM13.0417 10.9861L1.95833 10.9861L1.95833 12.3055L13.0417 12.3055L13.0417 10.9861Z",
    fill: "#1B407A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.625 0.166626L14.625 4.12496L0.375 4.12496L0.375 0.166625L14.625 0.166626ZM13.0417 1.48607L1.95833 1.48607L1.95833 2.80551L13.0417 2.80551L13.0417 1.48607Z",
    fill: "#1B407A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompare);
export default __webpack_public_path__ + "static/media/compare.d658e25c778fb3543d5ff197711c21b4.svg";
export { ForwardRef as ReactComponent };